/**
 * A landing picture in modern formats (ADR-0048): AVIF, then WebP, at the widths the layout needs (`<base>-<w>.avif`,
 * `<base>-<w>.webp` next to the JPEG in public/landing), and the original JPEG for browsers without either. The
 * <picture> box is display: contents (landing.css), so the layout rules for the <img> stay as they were.
 */
type Props = {
  /** Path without extension, e.g. /landing/art/streak. */
  base: string;
  widths: readonly number[];
  sizes: string;
  /** The JPEG fallback (also the intrinsic size below). */
  src: string;
  width: number;
  height: number;
  alt?: string;
  /** The hero: fetched at once with high priority instead of lazily. */
  priority?: boolean;
};

const set = (base: string, widths: readonly number[], ext: string) => widths.map((w) => `${base}-${w}.${ext} ${w}w`).join(", ");

export function Pic({ base, widths, sizes, src, width, height, alt = "", priority }: Props) {
  return (
    <picture>
      <source type="image/avif" srcSet={set(base, widths, "avif")} sizes={sizes} />
      <source type="image/webp" srcSet={set(base, widths, "webp")} sizes={sizes} />
      <img
        src={src}
        width={width}
        height={height}
        alt={alt}
        decoding="async"
        {...(priority ? { fetchPriority: "high" as const } : { loading: "lazy" as const })}
      />
    </picture>
  );
}
